<script setup lang="ts">
import {useDisplay} from "vuetify/framework";

interface Props {
    status?: string
}

const props = defineProps<Props>()

const {smAndUp} = useDisplay()

const goToHelp = () => {
    window.open('https://clinbiokb.sib.swiss/s/capacity-framework', '_blank')
}

const goToSIB = () => {
    window.open('https://www.sib.swiss', '_blank')
}

const writeMail = () => {
    window.location.href = 'mailto:capacity-framework-support@sib.swiss?subject=Capacity%20Framework%20Support'
}
</script>

<template>
    <v-app>
        <v-main>
            <v-container
                class="fill-height"
                fluid
            >
                <v-row
                    class="mt-0"
                    align="center"
                    justify="center"
                >
                    <v-col
                        v-if="props.status"
                        cols="12"
                        md="8"
                        class="d-flex justify-center"
                    >
                        <v-alert
                            variant="tonal"
                            type="info"
                            width="100"
                            closable
                        >
                            <span class="text-body-2 text-black">{{ props.status }}</span>
                        </v-alert>
                    </v-col>
                    <v-col
                        cols="12"
                        class="d-flex justify-center"
                    >
                        <v-sheet
                            :width="smAndUp ? 500 : '100%'"
                        >
                            <slot />
                        </v-sheet>
                    </v-col>
                </v-row>
            </v-container>
        </v-main>
        <v-footer
            class="border-t-sm"
            app
            absolute
        >
            <v-container
                class="text-start pa-0"
                width="70%"
            >
                <div
                    class="text-body-2 custom-link mr-5 d-inline-flex"
                    @click="goToHelp"
                >
                    Help
                </div>
                <div
                    class="text-body-2 custom-link mr-5 d-inline-flex"
                    @click="goToSIB"
                >
                    About SIB
                </div>
                <div
                    class="text-body-2 custom-link d-inline-flex"
                    @click="writeMail"
                >
                    Contact
                </div>
            </v-container>
        </v-footer>
    </v-app>
</template>

<style scoped>
</style>
